import React from 'react'
import { useTranslation } from 'react-i18next'
import TwoCol from '../../partials/TwoCol'

function InfoSection() {
  return (
    <section className="container">
      <TwoCol contentOne={<First />} contentTwo={<Second />} />
    </section>
  )
}

export default InfoSection

function First() {
  const { t } = useTranslation();

  return(
    <div className='d-flex flex-column'>
      <i className='bi bi-palette iconCol'></i>
      <h2 className='text-center'>{t('graphicDesign')}</h2>
      <p className='px-20'>{t('graphicDesignTxt')}</p>
    </div>
  );
}

function Second() {
  const { t } = useTranslation();

  return(
    <div className='d-flex flex-column'>
      <i className="bi bi-speedometer2 iconCol"></i>
      <h2 className='text-center'>{t('uiUxDesign')}</h2>
      <p className='px-20'>{t('uiUxDesignTxt')}</p>
    </div>
  );
}

function Third() {
  const { t } = useTranslation();

  return(
    <div className='d-flex flex-column'>
      <i className="bi bi-pc-display iconCol"></i>
      <h2 className='text-center'>{t('frontendDev')}</h2>
      <p className='px-20'>{t('frontendDevTxt')}</p>
    </div>
  );
}